<template>
  <div
    class="video-content-box"
    style="display: flex; flex-direction: column;"
    :style="{bottom: (facade.marginBottom || 60) + 'px'}"
    :class="{'align-start': facade.styleAlign === 'left', 'align-center': facade.styleAlign === 'center', 'align-end': facade.styleAlign === 'right'}"
  >
      <span :class="{'text-right': facade.styleAlign === 'right'}" :style="{fontSize: facade.fontSize + 'px', color: facade.fontColor || '#ffffff', marginBottom: facade.textBtnJj + 'px'}">{{ facade.text }}</span>
      <div style="display: flex; align-items: center;">
        <div v-if="facade.btnNub > 0 && facade.oneBtn" style="display: flex; position: relative;">
          <button
            class="video-btn"
            @click="goDetail(facade.onelink)"
            :style="{fontSize: facade.btnSize + 'px', color: facade.btnColor || '#ffffff', borderColor: facade.btnColor || '#ffffff', height: facade.btnHeight + 'px',  lineHeight: facade.btnHeight + 'px', borderRadius: facade.btnRadius + 'px'}"
          >
            {{ facade.oneBtn }}
          </button>
        </div>
        <div v-if="facade.btnNub == 2 && facade.twoBtn" style="display: flex; position: relative;" :style="{marginLeft: facade.btnJj + 'px'}">
          <button
            class="video-btn"
            @click="goDetail(facade.twolink)"
            :style="{fontSize: facade.btnSize + 'px', color: facade.btnColor || '#ffffff', borderColor: facade.btnColor || '#ffffff', height: facade.btnHeight + 'px',  lineHeight: facade.btnHeight + 'px', borderRadius: facade.btnRadius + 'px'}"
          >
            {{ facade.twoBtn }}
          </button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  methods: {
    goDetail(link) {
      console.log('video:', link)
      if (link && link.jumpType !== 'share' && link.jumpType !== 'contact') {
        this.$emit('go-next', link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-content-box{
  position: absolute;
  width: calc(100% - 24px);
  left: 12px;
  .video-btn{
    margin: 0;
    padding: 0 20px;
    border: 1px solid #ffffff;
		background: none;
  }
}
</style>